module.exports = __webpack_public_path__ + "img/lessThan.62af5bc7.svg";